import Glide from '@glidejs/glide';
import { initWhenVisible } from '../_shared/lazy-init';

( () => {
	const BLOCK_CLASS = 'wp-block-phrase-com-carousel';
	const blocks = document.querySelectorAll( `.${ BLOCK_CLASS }` );
	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( block ) => {
		const slider = block.querySelector< HTMLDivElement >( `.${ BLOCK_CLASS }__slider` );
		if ( ! slider ) {
			return;
		}

		const tabs = block.querySelectorAll< HTMLAnchorElement >( `.${ BLOCK_CLASS }__tab` );
		if ( ! tabs.length ) {
			return;
		}

		initWhenVisible( block, () => {
			const glide = new Glide( slider, {
				type: 'carousel',
				gap: 10,
				perView: 1,
				keyboard: false,
			} );

			tabs.forEach( ( tab ) => {
				tab.addEventListener( 'click', () => {
					glide.go( `=${ tab.dataset.index }` );
				} );
			} );

			const updateActiveTab = ( index: string ) => {
				tabs.forEach( ( tab ) => {
					tab.classList.toggle( 'is-active', tab.dataset.index === index );
				} );
			};

			glide.on( 'mount.after', () => {
				updateActiveTab( glide.index.toString() );
			} );

			glide.on( 'run', () => {
				updateActiveTab( glide.index.toString() );
			} );

			glide.mount();
		} );
	} );
} )();
